define('view/form/external.org.finder.content.view',['require','exports','module','underscore','uikit/uikit','backbone.radio','./base.finder.content.view','model/provisional.organization.model','../finder/external.org.finder.view'],function(require, exports, module) {
  //prettier-ignore
  var _                            = require('underscore'),
      UIKit                        = require('uikit/uikit'),
      Radio                        = require('backbone.radio'),
      BaseFinderContentView        = require('./base.finder.content.view'),
      ProvisionalOrganizationModel = require('model/provisional.organization.model'),
      ExternalOrgFinderView        = require('../finder/external.org.finder.view');
      disclosureChangeChannel      = Radio.channel('disclosureChangeChannel');

  var ExternalOrgFinderPreviewAnswerInsideTableEmptyView = BaseFinderContentView.PreviewAnswerInsideTableEmptyView.extend(
    {
      internalViewOptions: BaseFinderContentView.PreviewAnswerInsideTableEmptyView.extendInternalViewOptions({
        emptyTextView: {
          text: 'No external organization selected.',
        },
        findButtonView: {
          text: 'Find external organization.',
        },
      }),
    }
  );

  var ExternalOrgFinderPreviewAnswerInsideTableView = BaseFinderContentView.PreviewAnswerInsideTableView.extend({
    options: _.extend({}, BaseFinderContentView.PreviewAnswerInsideTableView.prototype.options, {
      type: 'ExternalOrg',
      modalHeaderText: 'External Org Finder',
      finderEmptyView: ExternalOrgFinderPreviewAnswerInsideTableEmptyView,
    }),

    internalViewOptions: BaseFinderContentView.PreviewAnswerInsideTableView.extendInternalViewOptions({
      finderTableView: function() {
        return {
          columns: [
            {
              data: '',
              formatter: function(value, model, column, index) {
                return model.get('name');
              },
            },
          ],
        };
      },
    }),
  });

  var ExternalOrgFinderPreviewAnswerView = BaseFinderContentView.PreviewAnswerView.extend({
    options: _.extend({}, BaseFinderContentView.PreviewAnswerView.prototype.options, {
      type: 'ExternalOrg',
      modelClass: ProvisionalOrganizationModel,
      modalHeaderText: 'External Org Finder',
      finderChildView: ExternalOrgFinderView.SelectedTableRowView,
    }),

    internalViewOptions: BaseFinderContentView.PreviewAnswerView.extendInternalViewOptions({
      finderTableView: function() {
        return {
          columns: [{ text: 'External Org Name', data: 'name' }],
          emptyText: 'No External Org has been selected.',
        };
      },
      addButtonView: function() {
        return {
          text: 'Find External Org',
        };
      },
    }),
    behaviors: {
      removeExternalOrg: {
        behaviorClass: Mn.Behavior.extend({
          onFirstBeforeRender: function() {
          /////////// OLD code for test
       /*     this.listenTo(this, 'finderTableView:row:destroy:collection', function() {
              var disclosure = Radio.request('AppKit.resourceService', 'resource', 'disclosure');
              if(disclosure) {
                var disclosureId = disclosure.get('id');
                var orgModel = new ProvisionalOrganizationModel(
                    this.view.model
                        .get('answer')
                        .get('data')
                        .models[0].get('value')
                );
                orgModel.urlParams({disclosureId: disclosureId});
                orgModel.deleteExternalOrg();
              }

        */

         ////////////

            this.listenTo(disclosureChangeChannel, 'external-org-finder:extorg-removed', function(childViewModel) {
              var disclosure = Radio.request('AppKit.resourceService', 'resource', 'disclosure');
              console.log ("EVENT: extorg-removed");

              if(disclosure) {

                 var disclosureId = disclosure.get('id');
                 var orgModel = childViewModel;

                if(disclosureId) {
                  try {
                    orgModel.urlParams({disclosureId: disclosureId});
                    orgModel.deleteExternalOrg();
                    console.log("AFTER deleteExternalOrg from coi-service-v2");
                  } catch (err) {
                    console.log('Failed to deleteExternalOrg with disclosureId='+ disclosureId);
                  }
                }
                else {
                  console.log("disclosureId is not valid,- can't delete ExtOrg!");
                }

              } // disclosure

            });
          },
        }),
      },
    },
  });

  var ExternalOrgFinderContentView = BaseFinderContentView.extend({
    internalViewOptions: BaseFinderContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: ExternalOrgFinderPreviewAnswerView,
        };
      },
    }),
  });

  ExternalOrgFinderContentView.PreviewAnswerInsideTableView = ExternalOrgFinderPreviewAnswerInsideTableView;
  ExternalOrgFinderContentView.PreviewAnswerInsideTableEmptyView = ExternalOrgFinderPreviewAnswerInsideTableEmptyView;
  ExternalOrgFinderContentView.PreviewAnswerView = ExternalOrgFinderPreviewAnswerView;

  module.exports = ExternalOrgFinderContentView;
});

